import { render, staticRenderFns } from "./DocumentNotes.vue?vue&type=template&id=77f1a51a&scoped=true"
import script from "./DocumentNotes.vue?vue&type=script&lang=js"
export * from "./DocumentNotes.vue?vue&type=script&lang=js"
import style0 from "./DocumentNotes.vue?vue&type=style&index=0&id=77f1a51a&prod&lang=scss&scoped=true"
import style1 from "./DocumentNotes.vue?vue&type=style&index=1&id=77f1a51a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f1a51a",
  null
  
)

export default component.exports